import type { TaskStatus } from '../api';

const LABEL: Record<TaskStatus, string> = {
  pending: 'Queued',
  dialing: 'Dialing',
  in_call: 'On Call',
  completed: 'Complete',
  failed: 'Failed',
};

export function StatusPill({ status }: { status: TaskStatus }) {
  return (
    <span className={`status-pill status-${status}`}>
      <span className="status-pill-dot" />
      {LABEL[status]}
    </span>
  );
}
